import { Link, NavLink, useNavigate } from "react-router-dom"
import { useState, useEffect } from "react"
import BotonLogout from "../botonLogout/BotonLogout"

const Leftnavbar = () => {

    const [busqueda, setBusqueda] = useState("")


    useEffect(() => {
    }, [busqueda])

    let history = useNavigate()

    const nombre_usuario = (localStorage.getItem("nombre_usuario")) ? localStorage.getItem("nombre_usuario") : "Anónimo"

    const perfil = (localStorage.getItem("perfil")) ? localStorage.getItem("perfil") : "0"

    const handleSearch = () => {
        history(`/inventario?bus=${busqueda}`)
        setBusqueda("")
    }

    return (
        <aside className="main-sidebar sidebar-light-cyan elevation-3">

            <Link to="/dashboard" className="brand-link text-cyan text-bold">
                <span className="h2 brand-image"><i className="nav-icon fas fa-user-astronaut"></i></span>
                <span className="h2 text-bold brand-text"> Sisweb</span>
                <span className="text-xs brand-text"> v3.0</span>
            </Link>

            <div className="sidebar">
                <br />
                <div className="user-panel pt-1 d-flex border bg-light rounded">
                    <span className="pt-2 h2 text-cyan image"><i className="nav-icon fas fa-user-circle"></i></span>
                    <div className="info">                        
                        <span className="text-primary">{nombre_usuario}</span>
                        
                        <BotonLogout />
                    </div>
                </div>

                <form onSubmit={e => { e.preventDefault(); handleSearch() }} className="py-3 border-bottom" name="buscador_menu">
                    <div className="form-inline">
                        <div className="input-group">
                            <input className="form-control form-control-sidebar" type="search" placeholder="Buscar" aria-label="Buscar" value={busqueda} onChange={e => { setBusqueda(e.target.value) }} name="buscador_left" />
                            <div className="input-group-append">
                                <button className="btn btn-sidebar">
                                    <i className="fas fa-search fa-fw"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </form>

                <nav className="mt-3 nav nav-pills nav-sidebar flex-column ">
                    <ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
                        <li className="nav-item">
                            <NavLink to="/dashboard" className="nav-link">
                                <i className="nav-icon fas fa-chart-line"></i>
                                <p>Dashboard</p>
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to="/inventario" className="nav-link">
                                <i className="nav-icon fas fa-calendar-check"></i>
                                <p>Inventario</p>
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to="/catalogosap" className="nav-link">
                                <i className="nav-icon fas fa-list-alt"></i>
                                <p>Catálogo SAP</p>
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to="/almacen" className="nav-link">
                                <i className="nav-icon fas fa-dolly-flatbed"></i>
                                <p>Almacén Essalud</p>
                            </NavLink>
                        </li>
                        {
                            (perfil === "1") &&
                            <li className="nav-item">
                                <NavLink to="/chatbox-ia" className="nav-link">
                                    <i className="nav-icon fas fa-comment-dots"></i>
                                    <p>Chatbot IA</p>
                                </NavLink>
                            </li>
                        }                        
                    </ul>
                </nav>
            </div>
        </aside>
    )
}
export default Leftnavbar